import {platformAPI} from "../../../api/axiosConfig";
import {SirenMessageContent} from "../typedefs";
import {useQuery} from "react-query";

async function fetchSirenMessageContent(id: string | undefined) {
    if (!id) return null;
    const res = await platformAPI.get<SirenMessageContent>(`api/siren/message-contents/${id}`)
    return res.data
}

export function useGetSirenMessageContent(id: string | undefined) {
    const {data, isLoading, error, refetch} = useQuery(
        ["siren-message-content", id],
        () => fetchSirenMessageContent(id),
        {enabled: !!id, cacheTime: 0, refetchOnMount: true}
    );
    return {data, isLoading, error, refetch}
}
